module.exports = {
	"apertureWidth": "Largura da abertura",
	"apertureLength": "Comprimento da abertura",
	"apertureGap1": "Folga da abertura 1",
	"apertureGap2": "Folga da abertura 2",
	"ballDiameter": "Diâmetro da esfera",
	"bodyOffset": "Deslocamento do corpo",
	"bodyLength": "Comprimento do corpo",
	"bodyDiameter": "Diâmetro do corpo",
	"bodyHeight": "Altura do corpo",
	"bodyColor": "Cor do corpo",
	"componentFamily": "Família do componente",
	"colPitch": "Passo da coluna",
	"chipArrayNote": "* L1 e b1 são opcionais.",
	"crystalNote": "* Selecione uma dimensão opcional (D, D2, L). Diferentes combinações podem produzir diferentes tamanhos de plataforma de perímetro.",	
	"densityLevel": "Nível de densidade",	
	"femaleStandoffNote": "* A plataforma de furos de montagem é opcional. Para gerá-la, insira valores para as dimensões mostradas na imagem à esquerda. O diâmetro do furo (b) é usado para a geração de furos de montagem e para o modelo mecânico do espaçador sem rosqueamento interno.",
	"footprintOrigin": "Origem do perímetro",
	"hPinPitch": "Passo entre pinos horizontais",
	"hTerminalGap": "Folga do terminal horizontal",
	"hTerminalTailLength": "Comprimento da extremidade do terminal horizontal",
	"innerThreadDepth": "Profundidade da rosca interna",
	"innerThreadSize": "Tamanho da rosca interna",
	"innerThreadDesignation": "Designação da rosca interna",
	"leadDiameter": "Diâmetro da aproximação",
	"leadSpan": "Distância da aproximação",
	"leadSpan1": "Distância da aproximação 1",
	"leadSpan2": "Distância da aproximação 2",
	"leadShape": "Forma da aproximação",
	"largerTerminalLength": "Comprimento do terminal maior",
	"largerTerminalWidth": "Largura do terminal maior",
	"maleFemaleStandoffNote": "* A plataforma de furos de montagem é opcional. Para gerá-la, insira valores para as dimensões mostradas na imagem à esquerda. O diâmetro do furo (b) é usado para a geração de furos de montagem.",
	"mapSilkscreen": "Mapear tela de silkscreen para corpo",
	"optionalDimensionNote": "* Selecione uma dimensão opcional (D, D2, L). Diferentes combinações podem produzir diferentes tamanhos de plataforma de perímetro.",
	"oddTerminalLength": "Comprimento do terminal ímpar",
	"oddTerminalWidth": "Largura do terminal ímpar",
	"optionalDimension": "Dimensão opcional",	
	"partialThread": "Rosca parcial",	
	"pasteCoverage": "Cobertura de pasta",
	"producibilityLevel": "Nível de produtividade",
	"pinPitch": "Passo entre pinos",
	"padToHoleRatio": "Proporção plataforma-furo",
	"padRoundness": "Redondeza da plataforma",
	"pinNumbering": "Numeração de pinos",
	"postLength": "Comprimento do pilar",
	"postThreadSize": "Tamanho da rosca do pilar",
	"postThreadDesignation": "Designação da rosca do pilar",
	"rowPitch": "Passo da linha",
	"tabWidth": "Largura da tabulação",
	"tabLength": "Comprimento da tabulação",
	"terminalThickness": "Espessura do terminal",
	"terminalWidth": "Largura do terminal",
	"terminalLength": "Comprimento do terminal",
	"terminalGap": "Folga do terminal",
	"terminalCCGap": "Folga centro-centro do terminal",
	"terminalCCGap1": "Folga centro-centro do terminal 1",
	"terminalCCGap2": "Folga centro-centro do terminal 2",
	"terminalTailLength": "Comprimento da extremidade do terminal",
	"terminalPostLength": "Comprimento do pilar do terminal",
	"terminalType": "Tipo de terminal",	
	"threadDepth": "Profundidade da rosca",
	"threadSize": "Tamanho da rosca",
	"threadDesignation": "Designação da rosca",	
	"threaded": "Rosqueado",
	"truncateMiddlePin": "Pino central truncado",		
	"vPinPitch": "Passo entre pinos verticais",
	"vTerminalGap": "Folga do terminal vertical",
	"vTerminalTailLength": "Comprimento da extremidade do terminal vertical",
	"#Rows": "Nº de linhas",
	"#Cols": "Nº de colunas",
	"#Pins": "Nº de pinos",
	"#DPins": "Nº de pinos (lado D)",
	"#EPins": "Nº de pinos (lado E)",
	"padShape": "Forma da plataforma",
	"RESISTOR": "Resistor",
	"NONPOLARIZED_CAPACITOR": "Capacitor - não polarizado",
	"POLARIZED_CAPACITOR": "Capacitor polarizado",
	"DIODE": "Diodo",
	"FUSE": "Fusível",
	"INDUCTOR": "Indutor",
	"POLARIZED_INDUCTOR": "Indutor polarizado",
	"NONPOLARIZED_INDUCTOR": "Indutor - não polarizado",
	"LRCCW": "Sentido anti-horário a partir do canto inferior esquerdo",
	"LRCW": "Sentido horário a partir do canto superior esquerdo",
	"ZZBT": "Zigue-zague a partir do canto inferior esquerdo",
	"PIN_ONE": "Pino 1",
	"CENTER_PADS": "Centro de plataformas",
	"female": "Fêmea",
	"male": "Macho",
	"maleFemale": "Macho-fêmea",
	"ROUND": "Redondo",
	"HEX": "Hexagonal",
	"SQUARE": "Quadrado",
	"Round": "Redondo",
	"Square": "Quadrado",
	"RoundedSquare": "Quadrado arredondado",
	"Rectangle": "Retângulo",
	"Black": "Preto",
	"Green": "Verde",
	"Blue": "Azul",
	"Yellow": "Amarelo",
	"Amber": "Âmbar",
	"Brown": "Marrom",
	"Cyan": "Ciano",
	"Maroon": "Vermelho escuro",
	"Grey": "Cinza",
	"Silver": "Prateado",
	"Purple": "Roxo",
	"Red": "Vermelho",
	"White": "Branco",
	"Most (A)": "Mais (A)",
	"Nominal (B)": "Nominal (B)",
	"Least (C)": "Menos (C)",
	"Most (M)": "Mais (M)",
	"Nominal (N)": "Nominal (N)",
	"Least (L)": "Menos (L)",
	"IC": "Circuito integrado (IC)",
	"PRECISION_INDUCTOR": "Indutor de precisão",
	"LED": "LED",
	"THERMISTOR": "Termistor",
	"POLARIZED_DIODE": "Diodo",
	"VARISTOR": "Varistor",
	"FERRITE_BEAD": "Núcleo de ferrita",
	"SOIC_SOP": "SOIC, SOP",
	"QFP": "QFP",
	"CFP": "CFP",
	"CQFP": "CQFP",
	"QFN": "QFN",
	"SOT23": "SOT23",
	"SOTFL": "SOTFL",
	"SOT223": "SOT223",
	"TO_DPAK": "TO, DPAK",
	"SOT143": "SOT143",
	"CHIP": "Chip",
	"SOD": "SOD",
	"MOLDED_BODY": "Corpo moldado",
	"SODFL": "SODFL",
	"DFN_2": "DFN-2",
	"DFN_3": "DFN-3",
	"DFN_4": "DFN-4",
	"ECAP": "E-Cap",
	"CRYSTAL": "Cristal",
	"BGA": "BGA",
	"MELF": "MELF",
	"CHIP_ARRAY_TWO_SIDE_FLAT_CONCAVE": "Matriz de chips, 2 lados, planos/côncavos",
	"CHIP_ARRAY_FOUR_SIDE_FLAT_CONCAVE": "Matriz de chips, 4 lados, planos/côncavos",
	"CHIP_ARRAY_TWO_SIDE_CONVEX": "Matriz de chips, 2 lados, convexos",
	"PLCC": "PLCC",
	"OSCILLATOR_CORNER_CONCAVE": "Frequência de corte do oscilador, côncavo",
	"OSCILLATOR_J_LEAD": "Aproximação em J do oscilador",
	"OSCILLATOR_L_BEND": "Dobra em L do oscilador",
	"SOJ": "SOJ",
	"AXIAL": "Axial",
	"DIP": "DIP",
	"PIN_HEADER_STRAIGHT": "Conector de pinos (macho) - reto",
	"PIN_HEADER_RA": "Conector de pinos (macho) - ângulo reto",
	"RECEPTACLE_HEADER_STRAIGHT": "Conector de tomadas (fêmea) - reto",
	"RECEPTACLE_HEADER_RA": "Conector de tomadas (fêmea) - ângulo reto",
	"SON_DFN": "SON (DFN)",
	"RADIAL_GENERIC": "Genérico radial (redondo)",
	"RADIAL_LED": "LED radial (redondo)",
	"CRYSTAL_HC49": "Cristal (HC49)",
	"FEMALE_STANDOFF": "Distanciador/espaçador fêmea",
	"MALE_FEMALE_STANDOFF": "Distanciador macho-fêmea",
	"SNAP_LOCK": "Trava de pressão",
	"Optional_D": "D (Distância da aproximação)",
	"Optional_D2": "D2 (Folga do terminal)",
	"Optional_L": "L (Comprimento do terminal)",
	"CONCAVE": "Côncavo",
	"FLAT": "Plano",
	"Oblong": "Oblongo",
	"Collapsing_Ball": "Esfera colapsável",
	"Non_Collapsing_Ball": "Esfera não colapsável",
	"mountingHolePad": "Plataforma de furos de montagem",
	"withVias": "Com vias",
	"viasCount": "Contagem de vias",
	"viaDiameter": "Diâmetro da via",
	"viaOffset": "Deslocamento da via a partir do centro do furo",
	"viaThermalRelief": "Alívio térmico da via",
	"radialLedNote": "* c não é aplicável a formas de aproximação arredondadas.",
	"lockHeight": "Altura da trava",
	"overrideLockDiameter": "Substituir diâmetro da trava",
	"lockDiameter": "Diâmetro da trava",
	"overridePitch": "Substituir passo entre pinos",
	"bodyWidth": "Largura do corpo",
	"padWidth": "Largura da plataforma",
	"plated": "Chapeado",
	"ViaOffset": "Deslocamento da via a partir do centro do furo",
	"holeDiameter": "Diâmetro do furo",
	"snapLockNote1": "* O diâmetro da trava (E1) é calculado automaticamente com base no diâmetro do corpo (E) e no diâmetro do furo (b). No entanto, você pode fornecer um valor personalizado substituindo o diâmetro da trava.",
	"snapLockNote2": "* O diâmetro do furo (b) não pode ser igual ao diâmetro do corpo (E) e ao diâmetro da trava (E1)",
	"leadWidth": "Largura da aproximação",
	"leadThickness": "Espessura da aproximação",
	"boardThickness": "Espessura da placa",
	"error1": "Não implementado.",
	"fabricationTolerance": "Tolerância de fabricação", 
	"placementTolerance": "Tolerância de posicionamento",
	"CAPACITOR": "Capacitor - não polarizado",
	"CAPACITOR_NONPOLARIZED": "Capacitor - não polarizado",
	"CAPACITOR_NON_POLARIZED": "Capacitor - não polarizado",
	"FILTER": "Filtro", 
	"TRANSISTOR": "Transistor",
	"ecapNote": "* Selecione uma dimensão opcional (D, D2, L). Diferentes combinações podem produzir diferentes tamanhos de plataforma de perímetro.",
	"maximum": "Máximo", 
	"nominal": "Nominal", 
	"minimum": "Mínimo",
	"bodyShape": "Forma do corpo",
	"customSolderPaste": "Pasta de solda personalizada",
	"thermalPad": "Placa térmica",
	"thermalPadLength": "Comprimento da placa térmica",
	"thermalPadWidth": "Largura da placa térmica",
	"RoundedRectangle": "Retângulo arredondado",
	"extendedEdgeLength": "Comprimento da aresta estendida",
	"Generator": " Gerador",
	"axialNote": "* O passo entre pinos é calculado automaticamente com base no tamanho do corpo, no terminal e no nível de facilidade de fabricação para tornar o perímetro compatível com IPC. No entanto, você pode fornecer um valor personalizado ao substituir o passo entre pinos para criar um perímetro não compatível com IPC.",
	"baseHeight": "Altura da base",
	"CHIP_LED": "LED do chip",
	"updatePreview": "Atualizar visualização",
	"Custom": "Personalizado",
	"ledColorNote": "* Insira um valor em Hexadecimal para que o corpo tenha uma cor personalizada.",
	"customBodyColor": "Cor personalizada do corpo",							
	"lensShape": "Forma da lente",
	"domeDiameter": "Diâmetro da cúpula",
	"RECT_FLAT_TOP": "Retângulo com parte superior plana",
	"RECT_DOMED_TOP": "Retângulo com parte superior abobadada",
	'customFootprint': 'Perímetro personalizado',
	'customPadLength': 'Comprimento personalizado da plataforma',
	'customPadWidth': 'Largura personalizada da plataforma',
	'customPadGap': 'Folga personalizada plataforma-plataforma',
	'customOddPadWidth': 'Largura personalizada da plataforma ímpar',
	'customOddPadLength': 'Comprimento personalizado da plataforma ímpar',
	'customPadDiameter': 'Diâmetro personalizado da plataforma',
	'customPadSpan1': 'Distância personalizada da plataforma 1',
	'customPadSpan2' : 'Vão da plataforma personalizado 2',
	'customPadPitch' : 'Passo da plataforma personalizada',
	'pinPitch1' : 'Passo do pino 1',
	'customPadGap1': 'Folga plataforma-plataforma personalizada 1',
	'Optional_g': 'g (Folga personalizada da plataforma)',
	'Optional_p': 'p (Passo personalizado da plataforma)',

	// JS Widgets
	"New_Library": "Nova biblioteca",
	"Components": "Componentes",
	"Component": "Componente",
	"Symbols": "Símbolos",
	"Symbol": "Símbolo",
	"Footprints": "Perímetros",
	"Footprint": "Perímetro",
	"Packages": "Pacotes",
	"Package": "Pacote",
	"No": "Nenhum",
	"Name": "Nome",
	"Pins": "Pinos",
	"Pads": "Plataformas",
	"Description": "Descrição",
	"Variants": "Variantes",
	"Type": "Tipo",
	"Hub_URN": "Hub URN",
	"Hub_Version": "Hub Version",
	"Library_io_URN": "URN do Library.io",
	"Library_io_Version": "Versão do Library.io",
	"Link": "Vínculo",
	"Rename": 'Renomear',
	"Edit_Description": 'Editar descrição',
	"Duplicate": 'Duplicar', // verb, not noun.  ie "Make a copy"
	"Create_New_3D_Model": 'Criar novo modelo 3D',
	"Attach_Copy_Existing_3D_Model": 'Anexar cópia de modelo 3D existente',
	"Edit": 'Editar',
	"Delete": 'Excluir',
	"Remove_From": 'Remover de',
	"Update_To_Latest": 'Atualizar para o mais recente',
	"Create_New_Symbol": 'Criar novo símbolo',
	"Create_New_Footprint": 'Criar novo perímetro',
	"Create_New_Component": 'Criar novo componente',
	"Create_New_Package": 'Criar novo pacote',
	"Delete_Package_Children_Warning": "Isso também excluirá os pacotes usados por este perímetro.",
	"No_Search_Results": "Nenhum resultado de pesquisa.",
	"No_Library_Loaded": "Biblioteca não carregada.",
	"Library_Stored_Fusion_Hub": "Esta biblioteca está armazenada no your Fusion Hub.",
	"Library_Linked_Managed_Library": "Esta biblioteca está vinculada a uma biblioteca gerenciada do Library.io.",
	"Library_Local_Changes": "Esta biblioteca tem alterações que não foram enviadas para Library.io. Para fazer isso, acesse a barra de ferramentas  'Gerenciar'.",
	"Library_Remote_Changes": "Esta biblioteca tem novas atualizações que podem ser extraídas do Library.io. Para fazer isso, acesse a barra de ferramentas 'Gerenciar'.",
	"View_on_Library_io": "Visualizar no Library.io",
	"Used_In": "Usado em",
	"No_Selection": "Nenhuma seleção",

	"No_Footprints": "Nenhum perímetro",
	"No_Symbols": "Nenhum símbolo",
	"No_Components": "Nenhum componente",
	"No_Packages": "Nenhum pacote",

	"Package_Loading_Message": "Aguarde enquanto o pacote é salvo e carregado.",
	"Attributes": "Atributos",
	"View_Attributes": "Atributos de visualização",
	"Edit_Attributes": "Atributos de visualização",
	"Edit_Description": "Editar descrição",
	
	"Use_Placeholder": "Usar placeholder",
	"Placeholder_Message": "Use uma forma de placeholder quando nenhum modelo 3D estiver associado ao perímetro.",

	"Hub": "Hub",
	"New_Symbol": 'Novo símbolo',
	"New_Footprint": 'Novo perímetro',
	"New_Component": 'Novo componente',
	"New_Package": 'Novo pacote',

	"Asset_Ahead":  "Local changes are detected.  To publish these changes to Library.io, use the 'Manage' toolbar.",
	"Package_Behind_Lio": "A atualização do pacote Library.io está disponível. Clique com o botão direito do mouse e selecione Atualizar.",
	"Package_Behind_Fusion": "A atualização do pacote do Fusion está disponível. Clique com o botão direito do mouse e selecione Atualizar.",
	"Package_Behind_Both": "Há uma atualização de pacote disponível. Clique com o botão direito do mouse e selecione Atualizar.",
	"Package_On_Lio":  "This package exists only on Library.io.  Editing it will create a linked model in your Fusion Hub.",
	"Package_Behind_Blocked": "Para poder extrair alterações de recursos, a biblioteca deve ser atualizada. Para atualizar a biblioteca, use a barra de ferramentas 'Gerenciar'.",
}